import React, { useState, useEffect, useRef, useCallback } from 'react';
import GetDataApi from '../../Components/Common/FetchData/GetDataApi';
import { debounce } from '../../Components/Common/debounce';
import { Form, InputGroup } from 'react-bootstrap';
import { RxCrossCircled } from 'react-icons/rx';
import { ICompanyProfileInfoRegister } from '../../Types/RegisterTypes';
import { useGetExhibitorSearchList } from '../Exhibitor/apiEndpoints/exhibitorApiEndpoints';
type IProps = {
  label?: string;
  placeholder?: string;
  onChange?: (data: ICompanyProfileInfoRegister | null) => void;
};

const ToabMemberSearchByName = ({ label, placeholder, onChange }: IProps) => {
  const [exhibotorTerm, setExhibitorTerm] = useState<string>('');
  //   const { data?.data?, loading, getData } = GetDataApi<ICompanyProfileInfoRegister[]>(
  //     `/api/fair/exhibitor/list?name=${exhibotorTerm}`,
  //     true
  //   );

  const { refetch, data, isLoading } = useGetExhibitorSearchList({
    searchParams: exhibotorTerm,
  });
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [selectedValue, setSelectedValue] =
    useState<ICompanyProfileInfoRegister | null>();
  const dropdownRef = useRef<HTMLDivElement>(null); // Reference to the dropdown wrapper

  //   useEffect(() => {
  //     if (exhibotorTerm) {
  //       getData();
  //     } else {
  //       getData();
  //     }
  //   }, [exhibotorTerm]);

  const handleSelect = (option: ICompanyProfileInfoRegister) => {
    setSelectedValue(option);
    setShowDropdown(false);
    onChange && onChange(option);
    setExhibitorTerm('');
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSearch = useCallback(
    debounce((value: string) => {
      setExhibitorTerm(value);
    }, 500),
    []
  );

  return (
    <div className='position-relative' ref={dropdownRef}>
      <div
        className='form-control'
        onClick={() => {
          setShowDropdown(!showDropdown);
        }}
        style={{ cursor: 'pointer', textAlign: 'start', position: 'relative' }}
      >
        {selectedValue?.companyName || (
            <span style={{ color: 'gray' }}>Select {placeholder || ''}</span>
          ) ||
          `Select ${label || ''}`}{' '}
        <span
          style={{ position: 'absolute', right: 5, zIndex: 100, top: 4 }}
          onClick={(e) => {
            e.stopPropagation();
            setSelectedValue(null);
            onChange && onChange(null);
          }}
        >
          <RxCrossCircled />
        </span>
      </div>
      {showDropdown && (
        <div
          className='position-absolute border bg-white w-100'
          style={{ zIndex: 1000 }}
        >
          <InputGroup onChange={(e: any) => handleSearch(e.target.value)}>
            <Form.Control
              placeholder={`Search ${placeholder || ''}`}
              aria-label='Username'
              aria-describedby='basic-addon1'
            />
          </InputGroup>

          <div
            style={{ maxHeight: '200px', overflow: 'auto', textAlign: 'start' }}
          >
            {isLoading ? (
              <div className='p-2'>Loading...</div>
            ) : data?.data?.length && data?.data ? (
              data?.data?.map((option) => (
                <div
                  key={option.memberId}
                  className='p-2 hover-bg-light selectfieldListHover'
                  onClick={() => handleSelect(option)}
                  style={{ cursor: 'pointer' }}
                >
                  {option.companyName}
                </div>
              ))
            ) : (
              <div className='p-2'>No results found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ToabMemberSearchByName;
